import services from '../../../services'

const state = {
}

const actions = {
  async getTenantList ({commit}, query) {
    return await services.tenancy_query(query)
  },
  async getTenantById ({commit}, query) {
    return (await services.tenancy_byId(query))
  },
  async addOneTenant ({commit}, query) {
    return await services.tenancy_addOne(query)
  },
  async updateOneTenant ({commit}, options) {
    return await services.tenancy_updateOne(options)
  },
  async deleteOneTenant ({commit}, id) {
    let params = {
      _id: id
    }
    return await services.tenancy_deleteOne({params: params})
  }
}

const mutations = {
}
export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/system/tenancy.js